import { render, staticRenderFns } from "./TrendingManga.vue?vue&type=template&id=600d161c&scoped=true&"
import script from "./TrendingManga.vue?vue&type=script&lang=js&"
export * from "./TrendingManga.vue?vue&type=script&lang=js&"
import style0 from "./TrendingManga.vue?vue&type=style&index=0&id=600d161c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600d161c",
  null
  
)

export default component.exports